<div>
    <h1>{{header}}</h1>
    <p-table [value]="propertyModelList" [reorderableColumns]="true" dataKey="id" editMode="row"
             [columns]="cols"
             (onRowReorder)="onRowReorder($event)">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th style="width:3rem"></th>
                <th pReorderableColumn>{{'properties.order' | translate}}</th>
                <th pReorderableColumn>{{'properties.key' | translate}}</th>
                <th pReorderableColumn>{{'properties.value' | translate}}</th>
                <th pReorderableColumn>EN</th>
                <!--<th pReorderableColumn>Lang</th>-->
                <!--<th pReorderableColumn>Gewichtung</th>-->

                <th *ngFor="let col of columns" pReorderableColumn>
                    {{col.header}}
                </th>

                <th style="width:8rem"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-columns="columns" let-property let-editing="editing" let-index="rowIndex" let-ri="rowIndex">
            <tr [pEditableRow]="property" [pReorderableRow]="index">
                <td>
                    <span class="pi pi-bars" pReorderableRowHandle></span>
                </td>
                <td>
                    {{index}}
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="property.dtype" readonly>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{property.dtype}}
                        </ng-template>
                    </p-cellEditor>
                </td>

                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="property.dkey" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{property.dkey}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="property.dtext" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{property.dtext}}
                        </ng-template>
                    </p-cellEditor>
                </td>
<!--                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            &lt;!&ndash;<input pInputText type="text" [(ngModel)]="property.language">&ndash;&gt;
                            <p-dropdown [options]="languages" [(ngModel)]="property.language"
                                        [style]="{'width':'100%'}"></p-dropdown>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{property.language}}
                        </ng-template>
                    </p-cellEditor>
                </td>-->
<!--                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="property.weighting" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{property.weighting}}
                        </ng-template>
                    </p-cellEditor>
                </td>-->

                <td pEditableColumn *ngFor="let col of columns">
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="property?.languageWertMap[col.field]" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{property?.languageWertMap[col.field]}}
                        </ng-template>
                    </p-cellEditor>
                </td>


                <td style="text-align:center">
                    <button *ngIf="!editing"
                            pButton pRipple
                            type="button"
                            pTooltip="{{'properties.edit' | translate}}"
                            showDelay="300"
                            tooltipPosition="right"
                            pInitEditableRow icon="pi pi-pencil"
                            (click)="onRowEditInit(property)" class="p-button-rounded p-button-text">
                    </button>
                    <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                            (click)="onRowEditSave(property)"
                            class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
                    <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                            (click)="onRowEditCancel(property, ri)"
                            class="p-button-rounded p-button-text p-button-danger"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <div class="float-right">

        <button pButton pRipple type="button" label="{{'properties.add_item' | translate}}" icon="pi pi-plus"
                class="p-button-outlined float-left" (click)="addNewProperty()"></button>
        <span class="float-left"> &nbsp; </span>
        <p-button label="{{'properties.save' | translate}}" icon="pi pi-check" class="float-left"
                  (click)="saveProperties()"></p-button>

    </div>

</div>




<!--

<div class="preference-table">
    <p-table
        [value]="propertyModelList"
        dataKey="id"
        [paginator]="true"
        [rows]="5"
        [rowsPerPageOptions]="[5, 10, 20]"
        [columns]="cols"
        [reorderableColumns]="false"
        [tableStyle]="{'min-width': '50rem'}">

        &lt;!&ndash; Table Header &ndash;&gt;
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th style="width:3rem"></th>
                <th pReorderableColumn></th>
                <th pReorderableColumn>Order</th>
                <th pReorderableColumn>Key</th>
                <th pReorderableColumn>Value</th>
                <th pReorderableColumn>En</th>

                <th *ngFor="let col of columns" pReorderableColumn>
                    {{col.header}}
                </th>

                <th style="width:8rem"></th>
            </tr>
        </ng-template>

        &lt;!&ndash; Table Body &ndash;&gt;
        <ng-template pTemplate="body"
                     let-property let-editing="editing" let-ri="rowIndex"
                     let-rowData let-columns="columns" let-index="rowIndex" let-expanded="expanded">
            <tr [pEditableRow]="property" [pReorderableRow]="index">
                &lt;!&ndash; Reorder Icon &ndash;&gt;
                <td>
                    <span class="pi pi-bars" pReorderableRowHandle></span>
                </td>

                &lt;!&ndash; Expand Button &ndash;&gt;
                <td>
                    <button
                        type="button"
                        pButton
                        pRipple
                        [pRowToggler]="rowData"
                        class="p-button-text p-button-rounded p-button-plain"
                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                    </button>
                </td>
                <td>
                    {{index}}
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="property.dtype" readonly>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{property.dtype}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="property.dkey" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{property.dkey}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="property.dtext" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{property.dtext}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td pEditableColumn *ngFor="let col of columns">
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="property?.languageWertMap[col.field]" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{property?.languageWertMap[col.field]}}
                        </ng-template>
                    </p-cellEditor>
                </td>


                <td style="text-align:center">
                    <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                            (click)="onRowEditInit(property)" class="p-button-rounded p-button-text"></button>
                    <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                            (click)="onRowEditSave(property)"
                            class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
                    <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                            (click)="onRowEditCancel(property, ri)"
                            class="p-button-rounded p-button-text p-button-danger"></button>
                </td>
            </tr>

        </ng-template>

        &lt;!&ndash; Row Expansion &ndash;&gt;
        <ng-template pTemplate="rowexpansion" let-rowData>
            <tr>
                <td colspan="5">
                    <div class="p-ml-2">
                        <p><strong>ID:</strong> {{ rowData.id }}</p>
                        <p><strong>Type:</strong> {{ rowData.dtype }}</p>
                        <p><strong>Key:</strong> {{ rowData.dkey }}</p>
                        <p><strong>Key (Int):</strong> {{ rowData.dkeyAsInt }}</p>
                        <p><strong>Text:</strong> {{ rowData.dtext }}</p>
                        <p><strong>Language:</strong> {{ rowData.language }}</p>
                    </div>
                </td>
            </tr>
        </ng-template>

    </p-table>

    <div class="float-right">

        <button pButton pRipple type="button" label="{{'sp-add-new-item' | translate}}" icon="pi pi-plus"
                class="p-button-outlined float-left" (click)="addNewProperty()"></button>
        <span class="float-left"> &nbsp; </span>
        <p-button label="{{'sp-save' | translate}}" icon="pi pi-check" class="float-left"
                  (click)="saveProperties()"></p-button>

    </div>
</div>
-->
